export default __webpack_public_path__ + "static/media/Filter.de251a1b.svg";